import React from 'react';
import { motion } from 'framer-motion';

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {['home', 'about', 'work', 'skills', 'testimonials', 'blog', 'contact'].map((item, index) => (
      <motion.a
        href={`#${item}`}
        key={item + index}
        className="app__navigation-dot"
        style={active === item ? { backgroundColor: '#000' } : {}}
        initial={{ scale: 1 }}
        animate={{
          scale: [1, 1.5, 1], // <-- made it bigger (1.3)
          filter: [
            'drop-shadow(0 0 0px rgba(30,30,30,0.4))',
            'drop-shadow(0 0 10px rgba(30,30,30,0.4))',
            'drop-shadow(0 0 0px rgba(30,30,30,0.4))',
          ],
        }}
        transition={{
          duration: 5, // slow breathing
          repeat: Infinity,
          repeatType: 'loop',
          ease: 'easeInOut',
          times: [0, 0.5, 1],
        }}
      />
    ))}
  </div>
);

export default NavigationDots;